import { ConvexReactClient } from "convex/react";
import { ConvexHttpClient } from "convex/browser";

const url = import.meta.env.VITE_CONVEX_URL;

// React client - used for reactive queries (useQuery) and mutations (faster subscription update)
export const convex = new ConvexReactClient(url);

// HTTP client - used for imperative one-shot queries from non-React code (stores)
export const convexClient = new ConvexHttpClient(url);
